<template>
  <div class="typewriter">
    <i class="el-icon-loading" v-if="!displayText"></i>
    <template v-if="displayText">
      <span>{{ displayText }}</span>
      <span v-if="showCursor" class="cursor">|</span>
    </template>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: "TypeWriter",
  props: {
    text: {
      type: String,
      default: ''
    },
    speed: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      displayText: '', // 当前显示的文本
      currentIndex: 0, // 当前处理的索引
      showCursor: true,
      typingInterval: null,
      localText: _.cloneDeep(this.text), // 使用本地状态来处理文本
      newTextQueue: [], // 待处理的新文本队列
      isTyping: false
    };
  },
  watch: {
    text(newText) {
      // 如果 newText 和 localText 不同，则将 newText 添加到队列中
      if (newText !== this.localText) {
        this.newTextQueue.push(newText);
        if (!this.isTyping) {
          this.startTyping();
        }
      }
    }
  },
  mounted() {
    this.startTyping();
  },
  methods: {
    startTyping() {
      if (this.isTyping) return; // 如果正在打字，则不启动新打字动画

      this.isTyping = true;
      this.typingInterval = setInterval(() => {
        if (this.currentIndex < this.localText.length) {
          this.displayText += this.localText.charAt(this.currentIndex);
          this.currentIndex++;
          this.$emit('chatInput')
        } else {
          clearInterval(this.typingInterval);
          this.typingInterval = null;
          this.showCursor = false;
          this.isTyping = false;
          if (this.newTextQueue.length > 0) {
            // 从队列中获取新文本并开始打字
            this.localText = this.newTextQueue.shift();
            this.currentIndex = 0;
            this.showCursor = true;
            this.startTyping(); // 继续打字
          } else {
            this.$emit('finished');
          }
        }
      }, this.speed);
    },
    appendText(newText) {
      // 如果正在打字，则将新文本添加到队列中
      if (this.isTyping) {
        this.newTextQueue.push(newText);
      } else {
        // 如果未开始打字，则将新文本直接添加到显示内容并启动打字
        this.localText = this.displayText + newText;
        this.currentIndex = this.displayText.length; // 从当前内容末尾开始
        this.startTyping(); // 启动打字
      }
    }
  }
}
</script>

<style scoped lang="scss">
.typewriter {

  .cursor {
    margin-left: 2px;
  }

}
</style>
